import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import setRules from '@/libs/rules';
import { citys } from '@/const/citys';
import { mapState } from 'vuex';
var rule = [{
  key: 'consigneeName',
  name: '客户姓名'
}, {
  key: 'consigneeDetails',
  name: '详细地址'
}, {
  key: 'consigneePhone',
  name: '手机号',
  validator: 'validatePhone'
}];
import express from '@/const/express';
var expressList = express.map(function (v) {
  return {
    label: v.company,
    value: v.code
  };
});
export default {
  meta: {
    title: '出库',
    auth: true,
    authorityValue: "store-order-management"
  },
  name: 'stay',
  data: function data() {
    return {
      expressList: expressList,
      tableData: [],
      formData: {},
      rules: {
        expressNumber: [{
          required: true,
          message: ' 请输入快递单号',
          trigger: 'blur'
        }],
        expressCompany: [{
          required: true,
          message: ' 请输入物流公司',
          trigger: 'blur'
        }]
      },
      detail: {},
      layer: {
        show: false,
        title: '',
        showButton: true,
        form: {},
        rules: setRules(rule)
      },
      layer2: {
        show: false,
        title: '修改出库地址',
        showButton: true,
        deliveryAddressId: '',
        options: [],
        width: '600px'
      },
      active: {},
      addressStr: ''
    };
  },
  filters: {
    deliveryAddress: function deliveryAddress(e) {
      var str = '';

      try {
        str = ['contactName', 'phoneNumber', 'province', 'city', 'district', 'details'].map(function (v) {
          return e[v];
        }).filter(function (v) {
          return v;
        }).join('，');
        this.addressStr = str;
      } catch (e) {}

      return str;
    },
    consigneeInfo: function consigneeInfo(e) {
      var str = '';

      try {
        str = ['consigneeProvince', 'consigneeCity', 'consigneeDistrict', 'consigneeDetails'].map(function (v) {
          return e[v];
        }).join('');
      } catch (e) {}

      return str;
    }
  },
  computed: _objectSpread({
    selfDataCity: function selfDataCity() {
      var atv = this.active;
      return [atv.consigneeProvince, atv.consigneeCity, atv.consigneeDistrict];
    }
  }, mapState('d2admin', {
    menu: function menu(state) {
      return state.permission.routeKey;
    }
  })),
  methods: {
    isShow: function isShow(auto) {
      return this.isBtnGroud(this.menu, auto);
    },
    editRemark: function editRemark() {
      var _this = this;

      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入备注'
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
          var value, params;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  value = _ref.value;
                  params = _objectSpread(_objectSpread({}, _this.$route.query), {}, {
                    storeRemark: value,
                    storeRemarkLevel: _this.detail.storeRemarkLevel
                  });
                  _context.next = 4;
                  return _this.$api.remark(params);

                case 4:
                  YL.message('修改成功');

                  _this.dataBind(_this.$route.query);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    getAddressList: function getAddressList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this2$$api$ad, records;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.layer2.show = true;
                _context2.next = 3;
                return _this2.$api.addressList({
                  addressType: 2,
                  pageSize: 999
                });

              case 3:
                _yield$_this2$$api$ad = _context2.sent;
                records = _yield$_this2$$api$ad.records;

                _this2.$set(_this2.layer2, 'options', records);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    clickOpenStay: function clickOpenStay(val) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var item;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$api.updateDeliveryAddress(_objectSpread({}, _this3.detail));

              case 2:
                YL.message('修改成功');
                _this3.layer2.show = false;
                setTimeout(function () {
                  _this3.dataBind(_this3.$route.query);
                }, 500);
                return _context3.abrupt("return");

              case 8:
                item = _this3.layer2.options.find(function (v) {
                  return v.addressId == _this3.detail.deliveryAddressId;
                });

                _this3.$set(_this3.detail, 'deliveryAddress', _objectSpread({}, item));

                _this3.layer2.show = false;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleNav: function handleNav(NAME, row) {
      this.$router.push({
        name: NAME,
        query: row ? row : ''
      });
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.layer.form, 'consigneeProvince', e[0]);
      e[1] && this.$set(this.layer.form, 'consigneeCity', e[1]);
      e[2] && this.$set(this.layer.form, 'consigneeDistrict', e[2]);
    },
    clickLayer: function clickLayer(item, row) {
      this.active = _objectSpread(_objectSpread({}, item), row);
      this.layer.form = _objectSpread({}, row);
      this.layer.show = true;
      this.layer.title = item.title;
    },
    dataBind: function dataBind(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var orderDetails;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$api.orderDetails(_objectSpread({}, item));

              case 2:
                orderDetails = _context4.sent;
                _this4.detail = orderDetails;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    confirm: function confirm() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.$refs.layerForm.validate( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!valid) {
                              _context5.next = 7;
                              break;
                            }

                            citys.forEach(function (e) {
                              if (_this5.layer.form.consigneeProvince == e.label.split('市')[0] || e.label.split('省')[0] || e.label.split('壮族自治区')[0]) {
                                _this5.$set(_this5.layer.form, 'provinceCode', e.value);

                                e.children.forEach(function (_e) {
                                  if (_this5.layer.form.consigneeCity == _e.label) {
                                    _this5.$set(_this5.layer.form, 'cityCode', _e.value);

                                    _e.children.forEach(function (__e) {
                                      if (_this5.layer.form.consigneeDistrict == __e.label) {
                                        _this5.$set(_this5.layer.form, 'districtCode', __e.value);
                                      }
                                    });
                                  }
                                });
                              }
                            });
                            _context5.next = 4;
                            return _this5.$api[_this5.active.type]({
                              consigneeInfo: _objectSpread({}, _this5.layer.form),
                              orderId: _this5.active.orderId
                            });

                          case 4:
                            _this5.$notify.success({
                              title: '成功',
                              message: '修改成功'
                            });

                            _this5.dataBind(_this5.$route.query);

                            _this5.layer.show = false;

                          case 7:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    submin: function submin() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this6.$refs.formData.validate( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (valid) {
                              _context7.next = 2;
                              break;
                            }

                            return _context7.abrupt("return");

                          case 2:
                            _context7.next = 4;
                            return _this6.$api.delivery(_objectSpread(_objectSpread({
                              deliveryAddressId: _this6.detail.deliveryAddressId
                            }, _this6.formData), _this6.$route.query));

                          case 4:
                            _this6.$notify.success({
                              title: '成功',
                              message: '出库成功'
                            });

                            _this6.goBack();

                          case 6:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    copyThat: function copyThat() {
      YL.copyThat(this.detail.orderNo);
    }
  },
  created: function created() {
    this.dataBind(this.$route.query);
  }
};